var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMorning = function SvgMorning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m726.31-562.15-42.16-43.39 77.54-76.3 42.15 42.15-77.53 77.54ZM90-170v-60h780v60H90Zm360-505.38v-107.7h60v107.7h-60ZM233.69-563.39l-76.3-77.53 42.15-42.16 77.54 77.54-43.39 42.15ZM297-400h366q-23-54-72.19-87T480-520q-61.62 0-110.81 33Q320-454 297-400Zm-74.69 60q6.92-102 80.92-171T480-580q102.77 0 176.77 69 74 69 80.92 171H222.31ZM480-400Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMorning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "morning.28b90248c77f2ad3021b99924fa9b7db.svg";